import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './contact3.css'

const Contact3 = (props) => {
  return (
    <div
      className={`contact3-contact20 thq-section-padding ${props.rootClassName} `}
    >
      <div className="contact3-max-width thq-section-max-width">
        <div className="contact3-section-title">
          <span>
            {props.content2 ?? (
              <Fragment>
                <span className="contact3-text22 thq-body-small">
                  Our team is here to help you on your journey to success.
                </span>
              </Fragment>
            )}
          </span>
          <div className="contact3-content1">
            <h2>
              {props.heading1 ?? (
                <Fragment>
                  <h2 className="contact3-text24 thq-heading-2">Contact Us</h2>
                </Fragment>
              )}
            </h2>
            <p>
              {props.content1 ?? (
                <Fragment>
                  <p className="contact3-text19 thq-body-large">
                    <span>
                      Feel free to reach out to us for any inquiries or
                      assistance.
                    </span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </p>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="contact3-row">
          <div className="contact3-content2">
            <svg viewBox="0 0 1024 1024" className="thq-icon-medium">
              <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
            </svg>
            <div className="contact3-contact-info1">
              <div className="contact3-content3">
                <h3 className="contact3-text13 thq-heading-3">Email</h3>
                <p>
                  {props.content3 ?? (
                    <Fragment>
                      <p className="contact3-text28 thq-body-large">
                        We look forward to hearing from you!
                      </p>
                    </Fragment>
                  )}
                </p>
              </div>
              <span>
                {props.email1 ?? (
                  <Fragment>
                    <span className="contact3-text26 thq-body-small">
                      info@flaredge.online
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="contact3-content4">
            <svg viewBox="0 0 1024 1024" className="thq-icon-medium">
              <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
            </svg>
            <div className="contact3-contact-info2">
              <div className="contact3-content5">
                <h3 className="contact3-text15 thq-heading-3">Phone</h3>
                <p>
                  {props.content4 ?? (
                    <Fragment>
                      <p className="contact3-text27 thq-body-large">
                        Feel free to call us
                      </p>
                    </Fragment>
                  )}
                </p>
              </div>
              <span>
                {props.phone1 ?? (
                  <Fragment>
                    <span className="contact3-text25 thq-body-small">
                      9826322168
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="contact3-content6">
            <svg viewBox="0 0 1024 1024" className="thq-icon-medium">
              <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"></path>
            </svg>
            <div className="contact3-contact-info3">
              <div className="contact3-content7">
                <h3 className="contact3-text17 thq-heading-3">Office</h3>
                <p>
                  {props.content5 ?? (
                    <Fragment>
                      <p className="contact3-text29 thq-body-large">
                        We look forward to hear from you!
                      </p>
                    </Fragment>
                  )}
                </p>
              </div>
              <span>
                {props.address1 ?? (
                  <Fragment>
                    <span className="contact3-text23 thq-body-small">
                      IIT tirupati
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Contact3.defaultProps = {
  content1: undefined,
  content2: undefined,
  address1: undefined,
  heading1: undefined,
  phone1: undefined,
  email1: undefined,
  content4: undefined,
  rootClassName: '',
  content3: undefined,
  content5: undefined,
}

Contact3.propTypes = {
  content1: PropTypes.element,
  content2: PropTypes.element,
  address1: PropTypes.element,
  heading1: PropTypes.element,
  phone1: PropTypes.element,
  email1: PropTypes.element,
  content4: PropTypes.element,
  rootClassName: PropTypes.string,
  content3: PropTypes.element,
  content5: PropTypes.element,
}

export default Contact3
